/*
 * the one Content-Disposition reader for every server download (reports, issues, audit). only a
 * plain file name is used, so a header can never steer the save path.
 */
const SAFE_FILE_NAME_RE = /^[A-Za-z0-9._-]{1,200}$/;

// The name in `attachment; filename=...`, or '' when absent, unreadable (CORS) or not a plain name.
// headers: axios's plain object or AxiosHeaders.
export const disposition_file_name = (headers) => {
  const h = headers || {};
  const raw = typeof h.get === 'function' ? h.get('content-disposition') : h['content-disposition'];
  const m = (typeof raw === 'string' ? raw : '').match(/filename="?([^";]+)"?/i);
  const name = m ? m[1].trim() : '';
  return SAFE_FILE_NAME_RE.test(name) ? name : '';
};
